import { put, call } from 'redux-saga/effects';
import {
	getLanguagesService,
	registerUserService,
	loginUserService,
	confirmTokenService,
	forgotPasswordService,
	setNewPasswordService,
	changeUserPasswordService,
	changeUserEmailService,
} from '../services/registrationService';
import { getLiteralsService } from '../services/literalsService';
import history from '../store/history';
import { setToken, removeToken } from '../utils/cookieToken';
import { successCodes } from '../static/errors';

import * as types from '../store/constants';

export function* getLangSaga() {
	yield put({ type: `${types.GET_LANGUAGES + types.REQUEST}` });
	try {
		const response = yield call(getLanguagesService);
		yield put({ type: `${types.GET_LANGUAGES + types.SUCCESS}`, payload: response });
	} catch (error) {
		yield put({ type: `${types.GET_LANGUAGES + types.ERROR}`, payload: error });
	}
}

export function* getLiteralsSaga(payload) {
	yield put({ type: `${types.GET_LITERALS + types.REQUEST}` });
	try {
		const response = yield call(getLiteralsService, payload);
		yield put({ type: `${types.GET_LITERALS + types.SUCCESS}`, payload: response });
	} catch (error) {
		yield put({ type: `${types.GET_LITERALS + types.ERROR}`, payload: error });
	}
}

export function* registerSaga(payload) {
	yield put({ type: `${types.REGISTER_USER + types.REQUEST}` });
	try {
		const response = yield call(registerUserService, payload);
		yield put({ type: `${types.REGISTER_USER + types.SUCCESS}`, payload: response });
	} catch (error) {
		yield put({ type: `${types.REGISTER_USER + types.ERROR}`, payload: error });
	}
}

export function* loginSaga(payload) {
	yield put({ type: `${types.LOGIN_USER + types.REQUEST}` });
	try {
		const response = yield call(loginUserService, payload);
		const { header_value } = response;
		yield put({ type: `${types.LOGIN_USER + types.SUCCESS}` });
		yield call(setToken, header_value);
		yield call(history.push, '/account');
	} catch (error) {
		yield put({ type: `${types.LOGIN_USER + types.ERROR}`, payload: error });
	}
}

export function* logoutSaga() {
	yield put({ type: `${types.LOGOUT_USER + types.SUCCESS}` });
	yield call(removeToken);
	yield put({ type: types.RESET_USER });
	yield put({ type: types.RESET_STRUCTURE });
}

export function* confirmTokenSaga(payload) {
	yield put({ type: `${types.CONFIRM_TOKEN}${types.REQUEST}` });
	try {
		const response = yield call(confirmTokenService, payload);
		yield put({ type: `${types.CONFIRM_TOKEN}${types.SUCCESS}`, payload: response });
		yield call(history.push, '/');
	} catch (error) {
		yield put({ type: `${types.CONFIRM_TOKEN}${types.ERROR}`, payload: error });
	}
}

export function* forgotPassword(payload) {
	yield put({ type: `${types.FORGOT_PASSWORD}${types.REQUEST}` });
	try {
		const response = yield call(forgotPasswordService, payload);
		yield put({ type: `${types.FORGOT_PASSWORD}${types.SUCCESS}`, payload: response });
	} catch (error) {
		yield put({ type: `${types.FORGOT_PASSWORD}${types.ERROR}`, payload: error });
	}
}

export function* setNewPassword(payload) {
	yield put({ type: `${types.SET_NEW_PASSWORD}${types.REQUEST}` });
	try {
		const response = yield call(setNewPasswordService, payload);
		yield put({ type: `${types.SET_NEW_PASSWORD}${types.SUCCESS}`, payload: response });
	} catch (error) {
		yield put({ type: `${types.SET_NEW_PASSWORD}${types.ERROR}`, payload: error });
	}
}

export function* changeUserPasswordSaga(payload) {
	yield put({ type: `${types.CHANGE_USER_PASSWORD}${types.REQUEST}` });
	try {
		yield call(changeUserPasswordService, payload);
		yield put({ type: `${types.CHANGE_USER_PASSWORD}${types.SUCCESS}` });
		yield put({
			type: types.MODAL_SWITCH,
			payload: {
				oldModalName: types.ACCOUNT_MODAL_PASSWORD_CHANGE,
				newModalName: types.MODAL_SUCCESS,
				newModalData: { message: successCodes.changeUserPassword.message },
			},
		});
	} catch (error) {
		yield put({ type: `${types.CHANGE_USER_PASSWORD}${types.ERROR}`, payload: error });
	}
}

export function* changeUserEmailSaga(payload) {
	yield put({ type: `${types.CHANGE_USER_EMAIL}${types.REQUEST}` });
	try {
		yield call(changeUserEmailService, payload);
		yield put({ type: `${types.CHANGE_USER_EMAIL}${types.SUCCESS}` });
		yield put({
			type: types.MODAL_SWITCH,
			payload: {
				oldModalName: types.ACCOUNT_MODAL_EMAIL_CHANGE,
				newModalName: types.MODAL_SUCCESS,
				newModalData: { message: successCodes.changeUserEmail.message },
			},
		});
	} catch (error) {
		yield put({ type: `${types.CHANGE_USER_EMAIL}${types.ERROR}`, payload: error });
	}
}
